import { render } from "./CorrespondencesView.vue?vue&type=template&id=1659ef0b"
import script from "./CorrespondencesView.vue?vue&type=script&lang=js"
export * from "./CorrespondencesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__